export const visit = (vm, at) => {
at({ "en": { "calling-orchestration-shared-library": { "alert-store": { "updateSuccess": { "message": "Your settings were updated.", "title": "Success." }, "updateFailure": { "message": "Please try again.", "title": "Sorry. An error occurred." } } } } });
};